import React from "react";

function MiProgresoTituloComponent() {
  return (
    <div
      className="header-titulo titleSectionPrograma"
      style={{ marginTop: 30, marginBottom: 20 }}
    >
      Mi progreso
    </div>
  );
}

export default MiProgresoTituloComponent;
